import { render, staticRenderFns } from "./edit-personalized-assignments.vue?vue&type=template&id=93a5263e&scoped=true&"
import script from "./edit-personalized-assignments.vue?vue&type=script&lang=js&"
export * from "./edit-personalized-assignments.vue?vue&type=script&lang=js&"
import style0 from "./edit-personalized-assignments.vue?vue&type=style&index=0&id=93a5263e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a5263e",
  null
  
)

export default component.exports